import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const TaskRepository = RepositoryFactory.get('task')

class RiderService {
  static async getTasks (params) {
    try {
      return await TaskRepository.getTasks(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default RiderService
